import { Button, Modal } from "antd";
import React from "react";

type StaffMemberLimitReachedModalType = {
  open: boolean;
  onClose: () => void;
};

const StaffMemberLimitReachedModal = ({
  onClose,
  open = false
}: StaffMemberLimitReachedModalType) => {
  return (
    <Modal
      title="Staff member limit reached"
      open={open}
      closable={true}
      maskClosable={false}
      onCancel={onClose}
      footer={[
        <Button onClick={onClose} key="OK" type="primary">
          OK
        </Button>
      ]}
    >
      You’ve reached the maximum user limit for your school. To add a new staff member, delete an
      existing staff member.
    </Modal>
  );
};
export default StaffMemberLimitReachedModal;
